<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $tc("add") }} {{ $tc("refund", 1) }}</div>
      <router-link class="btn-blue" to="refund"
        >{{ $tc("refund", 1) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-2 mb-1 align-self-center">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.cinema.length > 0 ? 'shift-up' : ''">{{
                $tc("cinema", 1)
              }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                    v-b-tooltip.hover
                  :title="$t('refund_Cinema')"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="
                    onSelectCinema($event, Cinema.cine_id, Cinema.cine_name)
                  "
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!--Tooltip :title="$t('refund_Cinema')" /--->
          </div>
          <p class="error_message" style="margin-top:3px">
            <span v-if="submitted && selected.cinema.length == 0"
              >Please select cinema.</span
            >
          </p>
        </div>

        <div class="col-md-2 mb-1 align-self-center">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.screen.length > 0 ? 'shift-up' : ''">{{
                $tc("screen")
              }}</label>
              <b-dropdown
                :text="selected.screen"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Screen"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchScreen()"
                    v-on:keydown="onSearchScreen()"
                    v-on:search="onSearchScreen()"
                    v-model="searchScreen"
                    v-b-tooltip.hover
                  :title="$t('refund_Screens')"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Screen, ScreenIndex) in Screens"
                  @click="onSelectScreen($event, Screen)"
                  :key="ScreenIndex"
                  >{{ Screen.screen_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!--Tooltip :title="$t('refund_Screens')" /--->
          </div>
          <p class="error_message" style="margin-top:3px">
            <span v-if="submitted && selected.screen.length == 0">{{
              errmsg1
            }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-1 align-self-center">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.movie.length > 0 ? 'shift-up' : ''">{{
                $tc("movie", 1)
              }}</label>
              <!-- <b-dropdown
                :text="selected.movie"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Movie"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchMovie()"
                    v-on:keydown="onSearchMovie()"
                    v-model="searchMovie"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Movie, MovieIndex) in Movies"
                  v-on:click="onSelectMovie($event, Movie)"
                  :key="MovieIndex"
                  >{{ Movie.movie }}</b-dropdown-item
                >
              </b-dropdown> -->
              <multiselect
                v-model="searchMovie"
                :options="Movies"
                track-by="movie_id"
                label="movie"
                :multiple="false"
                @select="onSelectMovie"
                placeholder="Movie"
                :searchable="true"
                @search-change="onSearchMovie"
                v-b-tooltip.hover
                 :title="$t('refund_Movie')" 
              ></multiselect>
            </div>
            <!--Tooltip :title="$t('refund_Movie')" /-->
          </div>
          <p class="error_message" style="margin-top:3px">
            <span v-if="submitted && selected.movie.length == 0">{{
              errmsg2
            }}</span>
          </p>
        </div>
        <div class="col-md-2 mb-1 ">
          <div class="d-flex align-items-center pt-2">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="selected.date"
                  @click="cleardate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="onSelectDate($event)"
                  :value="selected.date"
                  :typeable="true"
                ></Datepicker>
                <label
                  :class="typeof selected.date == 'object' ? 'active' : ''"
                  >{{ $t("Show Date") }}</label
                >

              </div>
              
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-xl-2 mb-1 align-self-center">
          <button @click="onFetchData()" class="btn-blue-lg w-100">
            {{ $tc("submit") }}
          </button>
            <p class="error_message" style="margin-top:3px">
            
          </p>
        </div>

        <div class="col-12">
          <!-- SELECT DROPDOWN -->

          <div class="swc-report">
            <table class="swc-report-table" border="1">
              <thead class="bg-lightgrey">
                <tr>
                  <th>Cinema</th>
                  <th>Screen</th>
                  <th>Movie</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Create Refund</th>
                </tr>
              </thead>
              <tbody
                v-for="(show, userIndex) in Shows"
                :key="userIndex"
                class="sph-report light_grey_back"
              >
                <tr>
                  <td style="text-align:left">{{ show.cine_name }}</td>
                  <td style="text-align:left">{{ show.screen_name }}</td>
                  <td style="text-align:left">
                    {{ show.movie_name || show.movie_title }}
                  </td>
                  <td style="text-align:right">{{ show.ss_start_date | dateparse }}</td>

                  <td style="text-align:right">{{ show.ss_start_show_time }}</td>
                  <td>
                    <button @click="onClickEnbaleRefund(show)" class="btn-blue">
                      Enable Refund
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td colspan="6">
                    <p v-if="Shows.length == 0" class="text-center h6 mb-0">
                      {{ "No records found" }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Refund Modal -->
        <b-modal ref="enableRefund" title="Enable Refund" hide-footer show>
          <div>
            <div class="row mx-0">
              <div class="col-md-12 mb-4">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.refundReason.length > 0 ? 'shift-up' : ''
                      "
                      >{{ $t("refundReasons") }}</label
                    >
                    <b-dropdown
                      :text="selected.refundReason"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(RefundReason,
                        RefundReasonIndex) in RefundReasons"
                        v-on:click="onSelectRefundReason($event, RefundReason)"
                        :key="RefundReasonIndex"
                        >{{ RefundReason.rr_reason }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <Tooltip :title="$t('refund_RefundReason')" />
                </div>
                <p class="error_message">
                  <span v-if="refundSubmitted && !selected.refundReason">{{
                    errmsg4
                  }}</span>
                </p>
              </div>
              <div class="col-6 mx-auto">
                <button
                  v-on:click="onFinalSubmit(true)"
                  :disabled="btenable"
                  class="btn-blue mw-auto mr-3"
                >
                  Add Refund
                </button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import RefundService from "@/services/RefundService";
import scheduleService from "@/services/scheduleService";

export default {
  data() {
    return {
      MoviesCopy: [],
      searchMovie: "",
      ScreenCopy: [],
      searchScreen: "",
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      submitted: false,
      refundSubmitted: false,
      errmsg: "",
      errmsg1: "",
      errmsg2: "",
      errmsg3: "",
      errmsg4: "Please Select Refund Reason",
      // Saif
      Cinemas: [],
      Movies: [],
      Screens: [],
      ScheduleShowTimes: [],
      RefundReasons: [],
      selected: {
        cinema: "",
        movie: "",
        screen: "",
        show: "",
        refundReason: "",
        date: new Date()
      },
      selectedShow: {},
      refundObject: {
        cinema_id: null,
        screen_id: null,
        schedule_show_id: null,
        refund_reason_id: null,
        scd_is_active: "Y",
        //
        md_id: null
      },
      // Saif
      checked: "y",
      Shows: [],
      selectedNewDate: "",
      selecedCinema: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getMoviesList();
    this.getRefundReasonList();
  },
  mounted() {},
  methods: {
    cleardate() {
      this.selected.date = "";
    },
    onSearchMovie: function() {
      if (this.searchMovie && this.searchMovie.length > 0) {
        this.Movies = this.MoviesCopy.filter(x => {
          if (
            x.movie_title.toLowerCase().includes(this.searchMovie.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Movies = this.MoviesCopy;
      }
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchScreen: function() {
      if (this.searchScreen && this.searchScreen.length > 0) {
        this.Screens = this.ScreenCopy.filter(x => {
          if (
            x.screen_name
              .toLowerCase()
              .includes(this.searchScreen.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Screens = this.ScreenCopy;
      }
    },
    onResetForm: function() {},
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      // cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected.cinema = x.cine_name;
                this.onSelectCinema(event, x.cine_id, x.cine_name);
              }
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getMoviesList: function() {
      this.Movies = [];
      MovieService.GetActiveMoviesWithFormat({ movieversions: "Y" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Movies = data.Records;
            this.MoviesCopy = data.Records;
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getRefundReasonList: function() {
      this.RefundReasons = [];
      let payload = {
        tableName: "ms_refund_reasons",
        rr_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RefundReasons = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onFetchData: function() {
      this.submitted = true;
      if (this.selected.cinema.length == 0) {
        return;
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.refundObject.cinema_id,
          selectedDate: this.selected.date,
          screen_id: this.refundObject.screen_id || null,
          movie_details_id: this.refundObject.md_id || null
        };
        scheduleService
          .GetAllActiveSchedule(payload)
          .then(response => {
            const { data } = response;
            loader.hide();
            if (data && data.status) {
              this.Shows = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(error => {
            loader.hide();
            this.$toasted.show("Catch Error while fetching");
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      }
    },
    getActiveScreenByCinemaId: function(condition_id) {
      this.Screens = [];
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: condition_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Screens = data.Records;
            this.ScreenCopy = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onClickEnbaleRefund: function(showDetails) {
      this.selectedShow = showDetails;
      this.$refs.enableRefund.show();
    },
    onSelectCinema: function(event, cine_id, cine_name) {
      this.selected.cinema = cine_name;
      this.refundObject.cinema_id = cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
      this.getActiveScreenByCinemaId(cine_id);
    },
    onSelectDate: function(event) {
      this.selected.date = event;
    },
    onSelectMovie: function(params) {
      this.selected.movie = params.movie;
      this.refundObject.md_id = params.md_id;
      this.searchMovie = "";
      this.onSearchMovie();
    },
    onSelectScreen: function(event, params) {
      this.selected.screen = params.screen_name;
      this.refundObject.screen_id = params.screen_id;
    },
    onSelectRefundReason: function(event, params) {
      this.selected.refundReason = params.rr_reason;
      this.refundObject.refund_reason_id = params.rr_id;
    },

    resetCinema: function() {
      this.selected.screen = "Cinema";
      this.refundObject.cinema_id = null;
      this.Cinemas = [];
    },
    resetScreens: function() {
      this.selected.screen = "Screen";
      this.refundObject.screen_id = null;
      this.Screens = [];
    },
    resetShows: function() {
      this.selected.show = "show";
      this.refundObject.schedule_show_id = null;
      this.ScheduleShowTimes = [];
    },
    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.refundSubmitted = true;
      if (!this.refundObject.refund_reason_id) {
        this.$toasted.show("Please Select Refund Reason");
        return;
      }
      let payload = {
        cinema_id: this.selectedShow.cine_id,
        screen_id: this.selectedShow.screen_id,
        schedule_show_id: this.selectedShow.ss_id,
        refund_reason_id: this.refundObject.refund_reason_id,
        scd_is_active: "Y",
        md_id: this.selectedShow.md_id
      };
      RefundService.AddRefund(payload)
        .then(response => {
          this.btenable = false;
          const { data } = response;
          this.refundSubmitted = false;
          this.$refs.enableRefund.hide();
          if (data && data.status) {
            if (redirect) {
              this.$router.push({
                path: "/cinema-manager/refund"
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RefundComponents/addRefund.vue